import React, { useEffect } from "react";

const LANDING_PATHS = new Set(["/", "/introduction"]);

export function LandingLayout() {
  useEffect(() => {
    const apply = () => {
      const isLanding = LANDING_PATHS.has(window.location.pathname);
      document.body.classList.toggle("landing-page", isLanding);
    };
    apply();
    window.addEventListener("popstate", apply);
    const origPush = history.pushState;
    const origReplace = history.replaceState;
    history.pushState = function (...args) {
      const ret = origPush.apply(this, args);
      apply();
      return ret;
    };
    history.replaceState = function (...args) {
      const ret = origReplace.apply(this, args);
      apply();
      return ret;
    };
    return () => {
      window.removeEventListener("popstate", apply);
      history.pushState = origPush;
      history.replaceState = origReplace;
      document.body.classList.remove("landing-page");
    };
  }, []);

  return null;
}
